import { render, staticRenderFns } from "./formBaseAtex.vue?vue&type=template&id=8c210902&"
import script from "./formBaseAtex.vue?vue&type=script&lang=js&"
export * from "./formBaseAtex.vue?vue&type=script&lang=js&"
import style0 from "./formBaseAtex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports